module.exports = __webpack_public_path__ + "assets/img/coupon.38e69dcc.svg";